import {Component, ViewChild, AfterViewInit, OnChanges, Input, Output, EventEmitter} from '@angular/core';
import { productStyle } from './product-style';
import { ProductService } from './product.service';
import { FilterByCategory } from './filter-by-category.pipe';

import { NgxCarousel } from 'ngx-carousel';

@Component({
  selector: 'product-styles-slider',
  providers: [],
  templateUrl: 'product-styles-slider.component.html',
  styleUrls: ['product-styles-slider.css']
})

export class productStylesSlider{ 
  productStylesOptions: any;
  products=[];
  _category;

  @Input() currentSelectedProduct;
  // @Input() category : String;
  @Input('category')
  set name(category: string) {
     this._category = category;
     this.getCategoryStyles();
  }


  @Output() productStyleClicked:EventEmitter<number> = new EventEmitter<number>();


  constructor(private _productService: ProductService, public stylesCarousel: NgxCarousel) {
    
  } 

  ngOnInit(): void{
    this.getCategoryStyles();
    this.stylesCarousel = {
      grid: {xs: 2, sm: 3, md: 3, lg: 5, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: false,
      custom: 'banner'
    }
  }

  getCategoryStyles(){
    this._productService.getStyles(this._category)
    .subscribe((res)=>{
      console.log('Trying to get styles', res)
      this.products = res
    })
  }

  ngAfterViewInit() {
   }

  styleSelected(style){
    // console.log('[Product Styles Slider] Style selected', style)
    this.productStyleClicked.emit(style);
  }
  
  ngOnChanges(): void{
    // this.products = this._productService.getProducts();

    // console.log('something changed');
    // console.log(this.currentBaseProduct);
  }

  carouselLoaded($event){
    console.log('carousel loaded', $event);
  }
}

